import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Creatable from "react-select/creatable";
import { minDate } from "../../Constants/Constants";

const AddGovtOrder = ({ getData, formRef }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const [storeDiscom, setStoreDiscom] = useState([]);
  const [discomId, setDiscomId] = useState(null);
  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId ? selectedCompanyId : "",
    product_name_id: productId,
  });
  const [alloted, setAlloted] = useState([
    { product_name_id: "", alloted_qty: "" },
  ]);
  const [rowAddData, setRowAddData] = useState({
    company_id: "",
    product_name_id: "",
    o_m_circle: "",
    rca_number: "",
    alloted_qty: "",
    rca_date: "",
    bg_status: 0,
    bg_amount: 0,
    bg_number: "",
    validity: "",
  });

  function resetFileds() {
    setRowAddData({
      company_id: "",
      product_name_id: "",
      o_m_circle: "",
      rca_number: "",
      rca_date: "",
      alloted_qty: "",
      validity: "",
      bg_number: "",
      bg_status: 0,
      bg_amount: 0,
    });
    setSelectedCompanyId("");
    setProduct([]);
    setAlloted([{ product_name_id: "", alloted_qty: "" }]);
    setDiscomId("");
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDiscomChange = (selectedOption) => {
    console.log(selectedOption);
    setDiscomId(selectedOption);
  };

  const handleCreateOption = async (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    const success = await addDiscomData(newOption);
    if (success) {
      setStoreDiscom((prevOptions) => [...prevOptions, newOption]);
      setDiscomId(newOption);
    }
  };

  const getCompany = async () => {
    const BASE_URL = `${SERVER_URL}/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getProductDetails = async (e) => {
    const companyId = e.target.value ? parseInt(e.target.value) : "";

    if (!companyId) {
      setProduct([]);
      setProductId("");
      setfilterCriteria({ product_name_id: "" });
      setSelectedCompanyId(companyId);
      setfilterCriteria((prevFilterCriteria) => ({
        ...prevFilterCriteria,
        company_id: companyId,
      }));
      return;
    }

    setSelectedCompanyId(companyId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));

    const BASE_URL = `${SERVER_URL}/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: companyId,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      setProduct(result.data);
    } else {
      setProduct([]);
    }
  };

  const handleProductChange = (e) => {
    const productId = e.target.value !== "" ? parseInt(e.target.value) : "";
    setProductId(productId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      product_name_id: productId,
    }));
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      o_m_circle,
      rca_number,
      rca_date,
      bg_amount,
      bg_status,
      bg_number,
      validity,
    } = rowAddData;

    const BASE_URL = `${SERVER_URL}/api/govt-order/govt-order/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        alloted_details: alloted,
        discom_id: discomId?.value,
        rca_number,
        rca_date,
        bg_amount,
        bg_status,
        validity,
        bg_number,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      resetFileds();
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const handleChangeInput = (index, event) => {
    const values = [...alloted];
    if (event.target.name === "product_name_id") {
      values[index].product_name_id = event.target.value;
    } else {
      values[index].alloted_qty = event.target.value;
    }
    setAlloted(values);
  };

  const handleAddFields = () => {
    setAlloted([...alloted, { product_name_id: "", alloted_qty: "" }]);
  };

  const handleClose = (index) => {
    const values = [...alloted];
    values.splice(index, 1);
    setAlloted(values);
  };

  const getDiscomData = async () => {
    const BASE_URL = `${SERVER_URL}/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      const formattedDiscoms = result.data.map((discom) => ({
        value: discom.id,
        label: discom.discom_name,
      }));
      setStoreDiscom(formattedDiscoms);
    } else {
      setStoreDiscom([]);
    }
  };

  useEffect(() => {
    getDiscomData();
  }, []);

  const addDiscomData = async (newDiscom) => {
    const BASE_URL = `${SERVER_URL}/api/discom/discom-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discom_name: newDiscom.label,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      toast.success(result.message);
      return true;
    } else {
      toast.error(result.message);
      return false;
    }
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add RCA
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="party">Discom</label>
                            <Creatable
                              placeholder="Select or add discom"
                              onChange={handleDiscomChange}
                              onCreateOption={handleCreateOption}
                              options={storeDiscom}
                              isSearchable
                              isClearable
                              value={discomId}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Pole">Company Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="company_id"
                              id="company_id"
                              onChange={getProductDetails}
                              value={selectedCompanyId}
                              required
                              autoCapitalize="off"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => (
                                  <option
                                    value={item.id}
                                    key={id}
                                  >{`${item.company_name}, ${item.location}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="rca_date"
                              value={rowAddData.rca_date}
                              id="date"
                              placeholder="Date"
                              max={new Date().toISOString().split("T")[0]}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="rca">RCA.NO</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rca_number"
                              value={rowAddData.rca_number}
                              id="rca"
                              placeholder="RCA.NO"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="bg_status">BG Status</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="bg_status"
                              value={rowAddData.bg_status}
                              onChange={handleChange}
                              id="bg_status"
                            >
                              <option value="0">Not Submited</option>
                              <option value="1">Submited</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="amount">BG Amount</label>
                            <input
                              type="number"
                              className="form-control"
                              name="bg_amount"
                              value={rowAddData.bg_amount}
                              id="amount"
                              placeholder="BG Amount"
                              onChange={handleChange}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="bg_number">BG Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="bg_number"
                              value={rowAddData.bg_number}
                              id="bg_number"
                              placeholder="BG Number"
                              onChange={handleChange}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="validity">Validity</label>
                            <input
                              type="text"
                              className="form-control"
                              name="validity"
                              value={rowAddData.validity}
                              id="validity"
                              placeholder="Validity"
                              onChange={handleChange}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                      </div>
                      {alloted &&
                        alloted?.length > 0 &&
                        alloted?.map((item, index) => (
                          <div className="row" key={index}>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor={`product`}>Size</label>
                                <select
                                  className="form-control form-control-lg"
                                  onChange={(event) =>
                                    handleChangeInput(index, event)
                                  }
                                  name="product_name_id"
                                  value={item.product_name_id}
                                  disabled={!selectedCompanyId}
                                  id={`product`}
                                  required
                                >
                                  <option value="">Select Product (All)</option>
                                  {product &&
                                    product?.length > 0 &&
                                    product?.map((productItem, id) => (
                                      <option value={productItem.id} key={id}>
                                        {`${productItem.size}`}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor={`alloted`}>Alloted</label>
                                <div className="input-group">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="alloted_qty"
                                    id={`alloted`}
                                    value={item.alloted_qty}
                                    placeholder="Alloted"
                                    onChange={(event) =>
                                      handleChangeInput(index, event)
                                    }
                                    required
                                    autoComplete="off"
                                  />
                                  <span className="input-group-append ml-2">
                                    <div className="col-md-2">
                                      {index > 0 ? (
                                        <button
                                          type="button"
                                          title="Remove"
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() => handleClose(index)}
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          disabled
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                        >
                                          <i className="mdi mdi-close" />
                                        </button>
                                      )}
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      <span className="input-group-append ml-2">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleAddFields}
                        >
                          Add More
                        </button>
                      </span>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGovtOrder;
